export const logJSON = json => console.log(JSON.stringify(json, null, 2)); // eslint-disable-line no-console
